import axios from "axios";

import { checkIfTokenExpired } from "@vega-api/custom/utils/checkIfTokenExpired";
import { LocalStorageService } from "@vega-core/service/LocalStorage.service";
import { getBaseURL } from "@vega-core/utils/global";

const axiosConfig = {
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60_000,
  paramsSerializer: { indexes: null },
};

export const cleanAxiosInstanceWithToken = axios.create(axiosConfig);

// Attach Authorization header for every request if token exists
cleanAxiosInstanceWithToken.interceptors.request.use(
  async (config) => {
    const accessToken = LocalStorageService.getToken();

    if (!checkIfTokenExpired(accessToken)) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);
